import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import {
	Form,
	FormControl,
	FormField,
	FormItem,
	FormLabel,
} from "../../../components/ui/form";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import React from "react";
import Spinner from "../../../components/spinner.components";
import { useVerifyPhoneSendOtpBrandHttp } from "../../../hooks/http/brand/users/verify-phone-send-otp.brand.http";
import { handleHttpError } from "../../../utils/utils";
import { useToast } from "../../../hooks/use-toast";
import OTPPhone from "../../../components/otp-phone.components";
import { useAuthenticationStore } from "../../../store/authentication.store";

const FormSchema = z.object({
	phone: z.string().max(10),
});

const PhoneVerifyCommonPartial: React.FunctionComponent = () => {
	const { fetching, execute: sendPhoneOtpHttp } =
		useVerifyPhoneSendOtpBrandHttp();
	const { authenticationState, setAuthenticationState } =
		useAuthenticationStore();
	const [otpSent, setOtpSent] = React.useState<boolean>(false);
	const form = useForm<z.infer<typeof FormSchema>>({
		resolver: zodResolver(FormSchema),
		defaultValues: {
			phone: "",
		},
	});

	const { toast } = useToast();

	async function onSubmit(data: z.infer<typeof FormSchema>) {
		const response = await sendPhoneOtpHttp({
			body: {
				phoneNumber: data.phone,
			},
		});
		if (!response.success) {
			return handleHttpError(response, toast);
		}

			setOtpSent(true);
			setAuthenticationState({
				...authenticationState,
				phone: data.phone,
				otp: response.data
				
			});
		
	}

	if (otpSent) {
		return <OTPPhone />;
		// biome-ignore lint/style/noUselessElse: <explanation>
	} else {
		return (
			<div className="flex flex-col gap-10 w-full font-gliroy_regular">
				<div className="w-full font-gliroy_regular font-semibold">
					<h1 className="text-3xl">Secure your account</h1>
				</div>
				<Form {...form}>
					<form
						onSubmit={form.handleSubmit(onSubmit)}
						className="space-y-8 w-full"
					>
						<FormField
							control={form.control}
							name="phone"
							render={({ field }) => (
								<FormItem>
									<FormLabel className="font-semibold">
										Enter your mobile number
									</FormLabel>
									<FormControl className="relative">
										<div className="flex items-center">
											<Input
												type="number"
												typeof="number"
												maxLength={10}
												minLength={10}
												className="py-6 pl-24 h-16 text-lg placeholder:text-secondary tracking-wider"
												placeholder=""
												{...field}
											/>
											<div className="left-0 absolute ml-5 font-semibold text-lg tracking-wider cursor-pointer">
												(IN) +91
											</div>
										</div>
									</FormControl>
								</FormItem>
							)}
						/>

						<Button
							className="border-[--primary-button-border] bg-[--primary-button-bg] py-8 border w-full font-semibold text-[--primary-button-text] text-lg"
							type="submit"
						>
							{fetching ? <Spinner width={20} /> : "Get OTP"}
						</Button>
					</form>
				</Form>
			</div>
		);
	}
};

export default PhoneVerifyCommonPartial;
